import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HomeHero from './components/HomeHero';
import HomeCategories from './components/HomeCategories';
import HomeFeatured from './components/HomeFeatured';
import HomeLatest from './components/HomeLatest';
import HomeFAQ from './components/HomeFAQ';
import HomeCTA from './components/HomeCTA';
import { faqs } from '@/mocks/data';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <Navbar />
      <main>
        <HomeHero />
        <HomeCategories />
        <HomeFeatured />
        <HomeLatest />
        <HomeFAQ />
        <HomeCTA />
      </main>
      <Footer />
    </>
  );
}